import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { MainserviceService } from './../mainservice.service';

import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-game-detail',
  templateUrl: './game-detail.component.html',
  styleUrls: ['./game-detail.component.scss']
})
export class GameDetailComponent implements OnInit {
  p: number = 1; 
  p1: number = 1; 
  p2: number = 1; 

  order:any='wrong';
  order2:any ='wrong';
  reverse2:boolean=true;
  reverse:boolean =false;
  gameId:number;
  gamestat:any;
  game:any;
  leader:any;
  leaderId:number;
  gameCodes:any;
  shops:any;
  shopId:any;
  players:any;
  clues:any;

  constructor(
    private mainservice:MainserviceService,
    private route:ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit():void{
    this.getClues();

    this.route.paramMap.switchMap((params :ParamMap) =>
    this.mainservice.getGame(+params.get('id')))
    .subscribe( game => {this.game =game
    this.gameId =game.id

    this.mainservice.getGameStats(game.id)
   .subscribe(data => this.gamestat =data[0])

    this.mainservice.getStatistics("plays","shop?game="+game.id).subscribe( data =>
    {this.shops = data })

    this.mainservice.getStatistics("plays","users?game="+game.id).subscribe(data =>
    {this.players = data })



    this.mainservice.getLB(game.id).subscribe(data =>{
      this.leader =data[0]
      this.mainservice.getUser2(this.leader.user).subscribe(data =>
        {this.leaderId =data.id})
    })
    
    this.mainservice.getGamePromocodes(game.id).subscribe(data =>
    { this.gameCodes =data[0]})

  })

}
  getClues(){
    this.mainservice.getClues().subscribe(data =>{
      this.clues =data
    })
  }

  setOrder(nOrder:string){
    if(this.order === nOrder){
        this.reverse =!this.reverse;
    }
    this.order = nOrder;
  }
  setOrder2(nOrder:string){
    if(this.order2 === nOrder){
        this.reverse2 =!this.reverse2;
    }
    this.order2 = nOrder;
  }

  goBack():void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/game-detail/game-detail.component.ts